import styles from './TypeSelectorDropdown.module.scss';
import Icon from '../Icon';
import { useSelect } from 'downshift';
import { Text } from '../typography';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { customColors } from '../../utilities';

export default function ContextMenuDropdown({
  items,
  onChange,
  selected = {},
  type = null,
  noMargin = false,
}) {
  const { isOpen, getToggleButtonProps, getMenuProps, getItemProps } =
    useSelect({
      items: items,
      onSelectedItemChange: ({ selectedItem }) => onChange(selectedItem),
    });
  const { t } = useTranslation();
  if (!items?.length) {
    return <></>;
  }

  return (
    <div className={classNames(styles.container, noMargin && styles.noMargin)}>
      {type && (
        <Text noMargin weight="semiBold">
          {type}
        </Text>
      )}
      {items?.length > 1 ? (
        <div
          className={styles.selectable}
          data-cy={`type-selector-dropdown-selectable`}
        >
          <div
            className={classNames(styles.selector, noMargin && styles.noMargin)}
            {...getToggleButtonProps()}
          >
            <div className={styles.selectorDisplay}>
              {selected?.icon && (
                <Icon
                  style={{
                    color:
                      customColors[selected?.color?.toUpperCase()] ||
                      selected?.color,
                  }}
                >
                  {selected.icon}
                </Icon>
              )}
              <Text noMargin weight="semiBold">
                {t(selected?.title) || selected?.title || selected?.name}
              </Text>
            </div>
            <div>{isOpen ? <ExpandLess /> : <ExpandMore />}</div>
          </div>
          <div className={styles.options} {...getMenuProps()}>
            {isOpen && (
              <div>
                {items.map((item, index) => (
                  <div
                    data-cy={`type-selector-item-${item.title || item.name}`}
                    className={styles.option}
                    key={`${item.id}-${index}`}
                    {...getItemProps({
                      item,
                      index,
                    })}
                  >
                    {item?.icon && (
                      <Icon
                        style={{ color: item.color !== 'yellow' && item.color }}
                        baseClassName="material-icons-outlined"
                        className={styles[item.color]}
                      >
                        {item.icon}
                      </Icon>
                    )}
                    <Text noMargin weight="semiBold">
                      {item?.title ? t(item.title) || item?.title : item?.name}
                    </Text>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.selector} {...getToggleButtonProps()}>
            <div className={styles.selectorDisplay} {...getMenuProps()}>
              <Icon
                baseClassName="material-icons-outlined"
                style={{
                  color:
                    customColors[selected?.color.toUpperCase()] ||
                    selected?.color,
                }}
              >
                {selected?.icon}
              </Icon>
              <Text noMargin weight="semiBold">
                {t(selected?.title) || selected?.title || selected?.name}
              </Text>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
